import PropTypes from "prop-types";
import { Line } from "@react-three/drei";

const HOLE_COLOR = "#d32f2f";
const HOLE_LINE_WIDTH = 3; // in screen pixels

// The contours of the holes found in an incomplete scan, drawn on the cleaned
// mesh (in the mesh's own coordinates) to show the user what is missing.
// 'holes' - one flat array of numbers per hole: every 6 numbers are a line
// segment (x1, y1, z1, x2, y2, z2). The segments come in no particular order,
// so each is drawn on its own rather than as one connected line.
export const HoleContours = ({ holes }) => (
  <group>
    {(holes || []).map((segments, i) => (
      // drawn on top of the mesh (depthTest off) so the contour stays visible
      // from every angle, like the measurement annotations.
      <Line
        key={i}
        segments
        points={segments}
        color={HOLE_COLOR}
        lineWidth={HOLE_LINE_WIDTH}
        depthTest={false}
        toneMapped={false}
        renderOrder={10}
      />
    ))}
  </group>
);

HoleContours.propTypes = { holes: PropTypes.array };
